/* eslint-disable prettier/prettier */
import React, { useEffect, useState } from "react";
import { PROJECTS_LIST } from "../../Routes/Project/Project";
import { useNavigate, useParams } from "react-router-dom";
import { Breadcrumb, Card, Form, Table } from "react-bootstrap";
import CustomAsyncSelect from "../../Components/AsyncSelect";
import { BuyersAndSuppliers } from "../../Model/BuyersAndSuppliers/BuyersAndSuppliers";
import { XCircle, Download } from "react-bootstrap-icons";
import CustomButton from "../../Components/Button/CustomButton";
import { Projects } from "../../Model/Projects/Projects";
import { useDateFormat } from "../../Util/InputDateFormate";
import { DateFormat, DateString } from "../../Util/DateFormat";
import { setToast } from "../../Util/Toast";
import { getCookie } from "typescript-cookie";
import CreateRow from "../../Components/CreateRow";
import CustomSkeleton from "../../Components/CustomSkeleton";
import DatePicker from "react-datepicker";
import moment from "moment";
import { showErrorsInToasts } from "../../Util/ErrorMessageToast";
import QuotationRequestsCard from "./QuotationRequestsCard";
import { ProjectManufacturesQuotations } from "../../Model/Projects/ProjectManufacturesQuotations";
import { Ingredients } from "../../Model/Setting/Ingredients";
import AddUpdateingredients from "../../Pages/Setting/Ingredients/AddUpdate";
import AddUpdateconcentration from "../../Pages/Setting/Concentration/AddUpdate";
import {
  INGREDIENTS_LIST,
  INGREDIENTS_TITLE,
} from "../../Routes/Setting/Ingredients";
import { Concentration } from "../../Model/Setting/Concentration";
import {
  CONCENTRATION_LIST,
  CONCENTRATION_TITLE,
} from "../../Routes/Setting/Concentration";

type ProductDetails = {
  id: string;
  position: number | null;
  ingredients: string;
  dosage_form: string;
  filling: string;
  type_of_filling: string;
  concentrations: string;
  packaging_material: string;
  ingredient: {
    id: string;
    name: string;
  };
  concentration: {
    id: string;
    name: string;
  };
};
const AddUpdate = ({ permissions }: any) => {
  const navigate = useNavigate();
  const { id }: any = useParams();
  const dateFormat = useDateFormat();
  const [formData, setFormData] = useState<any>({});
  // const [items, setItems] = useState<any>([{ id: 1 }]);
  const [selectedManufacturers, setSelectedManufacturers] = useState<any>([]);
  const [disabledDraftRows, setDisabledDraftRows] = useState<boolean[]>([]);
  const [formErrors, setFormErrors] = useState<any>({});
  const [manufacturerError, setManufacturerError] = useState<any>(false);
  const [loading, setLoading] = useState<any>(true);
  const [loadingForSelectedManufacturers, setLoadingForSelectedManufacturers] =
    useState<any>(true);
  const [submitting, setSubmitting] = useState(false);
  const [ingredientsModalStatus, setIngredientsModalStatus] = useState(false);
  const [concentrationModalStatus, setConcentrationModalStatus] =
    useState(false);
  // Start DND
  const [products, setProducts] = useState<ProductDetails[]>([]);
  const [productFormErrors, setProductFormErrors] = useState<any>({});
  const [isUpdated, setIsUpdated] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const fileData = formData?.packaging_material;
  const fileName = fileData?.name || fileData?.split?.("/").pop?.();
  const fileUrl =
    fileData instanceof File ? URL.createObjectURL(fileData) : fileData;
  const [productDetails] = useState<ProductDetails>({
    id: "",
    position: null,
    ingredients: "",
    dosage_form: "",
    filling: "",
    type_of_filling: "",
    concentrations: "",
    packaging_material: "",
    ingredient: {
      id: "",
      name: "",
    },
    concentration: {
      id: "",
      name: "",
    },
  });
  const productTableFields = [
    {
      type: "CustomAsyncSelect",
      label: "ingredient",
      headerLabel: "Ingredients*",
      modal: Ingredients,
      isMenuPortalTarget: true,
      inputField: "name",
      fieldName: "name",
      submitFieldName: "ingredient_id",
      isMultiSelect: false,
      isNeedFullData: true,
      onChangeModalStatus: (status: boolean) =>
        setIngredientsModalStatus(status),
      modalStatus: ingredientsModalStatus,
      widget: (
        <AddUpdateingredients
          title={INGREDIENTS_TITLE}
          listRoute={INGREDIENTS_LIST}
          isNotUpdate={true}
          onChangeModalStatus={(status: boolean) =>
            setIngredientsModalStatus(status)
          }
        />
      ),
    },
    // {
    //   type: "text",
    //   label: "concentration",
    //   headerLabel: "Concentration*",
    //   fieldName: "concentration",
    //   submitFieldName: "concentration",
    // },
    {
      type: "CustomAsyncSelect",
      label: "concentration",
      headerLabel: "Concentration*",
      modal: Concentration,
      isMenuPortalTarget: true,
      inputField: "name",
      fieldName: "name",
      submitFieldName: "concentration_id",
      isMultiSelect: false,
      isNeedFullData: true,
      onChangeModalStatus: (status: boolean) =>
        setConcentrationModalStatus(status),
      modalStatus: concentrationModalStatus,
      widget: (
        <AddUpdateconcentration
          title={CONCENTRATION_TITLE}
          listRoute={CONCENTRATION_LIST}
          isNotUpdate={true}
          onChangeModalStatus={(status: boolean) =>
            setConcentrationModalStatus(status)
          }
        />
      ),
    },
    {
      type: "text",
      label: "comments",
      headerLabel: "Comments",
      fieldName: "comments",
      submitFieldName: "comments",
    },
  ];

  // End DND
  const getFormData = async (itemId: any) => {
    const item: any = await Projects.$query()
      .with([
        "buyer",
        "productManufactures",
        "products",
        "products.ingredient",
        "products.concentration",
        "productManufactures.supplier",
        "organization",
        "salesOwner",
      ])
      .find(itemId);
    return item.$attributes;
  };

  useEffect(() => {
    if (id) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, dateFormat]);

  const fetchData = async () => {
    try {
      const itemData = await getFormData(id);
      itemData &&
        setFormData({
          title: itemData.title,
          type_of_filling: itemData.type_of_filling,
          filling: itemData.filling,
          dosage_form: itemData.dosage_form,
          description: itemData.description,
          packaging_material: itemData.packaging_material,
          buyer_id: itemData.buyer
            ? {
                label: itemData.buyer.company_name,
                value: itemData.buyer.id,
              }
            : null,
          project_status: {
            label: itemData.project_status
              .split("_")
              .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" "),
            value: itemData.project_status,
          },
          project_value: itemData.project_value,
          expected_closed_date: DateString(
            itemData.expected_closed_date,
            dateFormat?.replace("dd", "DD"),
          ),
          productManufacturesArray: itemData.product_manufactures,
        });
      setProducts((prevState: any) => {
        const uniqueItems = new Set(prevState.map((item: any) => item.id)); // Extract unique ids
        const returnProduct = [
          ...prevState,
          ...itemData?.products
            .filter((item: any) => !uniqueItems.has(item?.id)) // Filter out duplicates
            .map((item: any, index: number) => ({
              ...item,
              position: item.position ?? index,
            })),
        ];

        return returnProduct.sort((a, b) => a.position - b.position);
      });
      setIsUpdated(true);

      const selectedManufacturers = itemData.product_manufactures.map(
        (manufacturer: any) => ({
          alreadyExist: true,
          id: manufacturer.id,
          mid: manufacturer.id,
          project_manufactures_status: {
            label: manufacturer.project_manufactures_status
              .split("_")
              .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" "),
            value: manufacturer.project_manufactures_status,
          },
          value: manufacturer.supplier.id,
          label: manufacturer.supplier.company_name,
        }),
      );
      setSelectedManufacturers(selectedManufacturers);
    } catch (error: any) {
      if (error.response?.data?.errors) {
        setToast("error", error.response.data.errors);
      } else if (error.response?.data?.message) {
        setToast("error", error.response.data.message);
      } else {
        setToast("error", "An error occurred while processing your request");
      }
    } finally {
      setLoadingForSelectedManufacturers(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!id && products?.length === 0) {
      setProducts([{ ...productDetails, position: 0 }]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const customTheme = (theme: any) => ({
    ...theme,
    spacing: {
      ...theme.spacing,
      controlHeight: 30,
      baseUnit: 2,
    },
  });

  const handleManufacturerChange: any = (
    selectedOption: any,
    index: any,
    newAdd: any,
  ) => {
    if (!newAdd) {
      const updatedManufacturers = [...selectedManufacturers];
      updatedManufacturers[index] = {
        ...selectedManufacturers[index], // Preserve other properties
        project_manufactures_status: selectedOption,
      };

      setSelectedManufacturers(updatedManufacturers);
    } else {
      const newManufacturer = {
        ...selectedOption[index],
        project_manufactures_status: { label: "Draft", value: "draft" },
        newAdded: true,
      };

      setSelectedManufacturers((prevManufacturers: any) => {
        const updatedManufacturers = [...prevManufacturers, newManufacturer];
        const updatedDisabledRows: any = updatedManufacturers.map(
          (manufacturer: any) => {
            return manufacturer.alreadyExist ? null : true;
          },
        );

        setDisabledDraftRows(updatedDisabledRows);

        const filteredManufacturers = updatedManufacturers.filter(
          (manufacturer: any) => {
            return (
              manufacturer.label &&
              manufacturer.value &&
              selectedOption.some(
                (option: any) => option.value === manufacturer.value,
              )
            );
          },
        );
        return filteredManufacturers;
      });
    }
  };

  const GoBack = () => {
    navigate(PROJECTS_LIST);
  };
  const cleanObject = (obj: any, fileds: any) => {
    for (var propName in obj) {
      if (
        !fileds.includes(propName) &&
        (obj[propName] === null ||
          obj[propName] === undefined ||
          obj[propName] === "")
      ) {
        delete obj[propName];
      } else if (typeof obj[propName] === "object") {
        cleanObject(obj[propName], fileds);
      }
    }
    return obj;
  };

  async function handleSubmit(AddManufacturers: boolean) {
    try {
      setSubmitting(true);
      let inputData: any = Object.assign({}, formData);
      let productErrors: any = {};
      // inputData.buyer_id = inputData.buyer_id?.value;
      inputData.buyer_id = inputData.buyer_id?.value ?? "";
      inputData.project_status = inputData.project_status?.value;
      const rowDataArray = products.map((item) => {
        const newItem: any = { ...item };
        if (newItem.comments === "null") {
          newItem.comments = "";
        }
        const fields = ["ingredients", "concentration", "comments"];
        return cleanObject(newItem, fields);
      });
      rowDataArray.every((item: any, index: number) => {
        Object.entries(item).forEach(([key, value]: [string, any]) => {
          if (
            !(value || key === "comments" || value === 0 || key === "position")
          ) {
            let errorKey = key
              .replace("id", "")
              .split("_")
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" ");
            const errorMessage = `${errorKey} is required`;
            productErrors[index] = {
              ...productErrors[index],
              [key]: errorMessage,
            };
          }
          if (
            key === "ingredient" &&
            (!value || Object.keys(value).length === 0)
          ) {
            productErrors[index] = {
              ...productErrors[index],
              ingredient_id: "Ingredients is required",
            };
          }
          if (
            key === "concentration" &&
            (!value || Object.keys(value).length === 0)
          ) {
            productErrors[index] = {
              ...productErrors[index],
              concentration_id: "Concentration is required",
            };
          }
        });
        return item;
      });
      setProductFormErrors(productErrors);
      const supplierIds = selectedManufacturers.map((manufacturer: any) => ({
        id: manufacturer.id,
        supplier_id: manufacturer.value,
        project_manufactures_status:
          manufacturer.project_manufactures_status.value, // Extracting only the value
      }));
      inputData.product_manufactures = supplierIds;
      inputData.expected_closed_date = inputData.expected_closed_date
        ? DateFormat(
            inputData.expected_closed_date,
            dateFormat.replace("dd", "DD"),
          )
        : "";
      const formdata: any = new FormData();
      rowDataArray.forEach((item, index) => {
        Object.entries(item).forEach(([key, value]) => {
          // Check if the value is an object or a string (assuming URLs are strings)
          if (key !== "updated_at" && key !== "created_at") {
            formdata.append(`products[${index}][${key}]`, value);
          }
        });
      });
      formdata.append("title", inputData.title);
      formdata.append("description", inputData.description);
      formdata.append("buyer_id", inputData.buyer_id);
      formdata.append("project_value", inputData.project_value);
      formdata.append("expected_closed_date", inputData.expected_closed_date);
      formdata.append("dosage_form", inputData.dosage_form);
      formdata.append("filling", inputData.filling);
      formdata.append("type_of_filling", inputData.type_of_filling);
      if (!id) {
        formdata.append("approve_status", "approval_waiting");
      }
      if (formData.packaging_material instanceof File) {
        formdata.append(
          "packaging_material",
          formData.packaging_material,
          formData.packaging_material.name,
        );
      }
      if (id) {
        formdata.append("project_status", inputData.project_status);
      } else {
        formdata.append("project_status", "draft");
      }
      selectedManufacturers.forEach((manufacturer: any, index: number) => {
        if (manufacturer.id) {
          formdata.append(
            `product_manufactures[${index}][id]`,
            manufacturer.id,
          );
        }
        formdata.append(
          `product_manufactures[${index}][supplier_id]`,
          manufacturer.value,
        );
        formdata.append(
          `product_manufactures[${index}][project_manufactures_status]`,
          manufacturer.project_manufactures_status.value,
        );
      });
      const errors: any = {};
      if (!inputData.title) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        errors.title = "Title is required";
      }
      if (!inputData.dosage_form) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        errors.dosage_form = "Dosage Form is required";
      }
      if (!inputData.filling) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        errors.filling = "Filling is required";
      }
      if (!inputData.type_of_filling) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        errors.type_of_filling = "Type Of Filling is required";
      }
      if (!inputData.packaging_material) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        errors.packaging_material = "Packaging Material is required";
      }
      if (!inputData.description) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        errors.description = "Description is required";
      }
      if (!inputData.project_status && id) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        errors.project_status = "Project status is required";
      }
      if (selectedManufacturers.length === 0) {
        setManufacturerError(true);
      } else {
        setManufacturerError(false);
      }

      const manufacturersValidations = selectedManufacturers.map(
        (manufacturer: any, index: number) => {
          const manufacturerErrors: any = {};

          if (!manufacturer.project_manufactures_status) {
            manufacturerErrors[
              `selectedManufacturers[${index}].project_manufactures_status`
            ] = "Status is required";
          }
          // Add similar validation for other manufacturer fields here

          return manufacturerErrors;
        },
      );

      // Merge errors from main form fields, product fields, and Select Manufacturers fields
      const allErrors = {
        ...errors,
        ...manufacturersValidations.reduce(
          (acc: any, curr: any) => ({ ...acc, ...curr }),
          {},
        ),
      };

      // Set form errors
      setFormErrors(allErrors);

      // Check if there are any errors
      if (Object.keys(allErrors).length > 0) {
        setToast("error", "Validation failed. Please check the form fields");
        return;
      }

      if (id) {
        formdata.append("_method", "put");
        const apiUrl = process.env.REACT_APP_API_URL as string;
        const BASE_URL = apiUrl + "api/";
        const token = getCookie("authToken");
        const headers = {
          Authorization: `Bearer ${token ? token.replace(/"/g, "") : ""}`,
        };

        const response = await fetch(`${BASE_URL}projects/${id}`, {
          method: "POST",
          headers: headers,
          body: formdata,
        });

        if (!response.ok) {
          const errorResponse = await response.json();
          throw new Error(errorResponse.message);
        }
        setToast("success", `Successfully Updated`);
      } else {
        await Projects.$query().store(formdata);
        setToast("success", `Successfully Added`);
      }
      if (AddManufacturers === false) {
        navigate(PROJECTS_LIST);
      } else if (AddManufacturers === true) {
        fetchData();
        setDisabledDraftRows([]);
      }
    } catch (error: any) {
      if (error.response && error.response.data) {
        showErrorsInToasts(error.response.data.errors);
      } else {
        const errorMessage =
          error instanceof Error
            ? error.message
            : "An error occurred while processing your request";
        setToast("error", errorMessage);
      }
    } finally {
      setSubmitting(false);
    }
  }
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, type, value, files } = e.target;
    if (type === "file" && files) {
      setFormData({
        ...formData,
        [name]: files[0], // Store the uploaded file
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };
  const removeManufacturer = (index: number) => {
    const updatedManufacturers = [...selectedManufacturers];
    updatedManufacturers.splice(index, 1);
    setSelectedManufacturers(updatedManufacturers);
  };
  const CustomFormSkeleton = () => (
    <div className="row p-2">
      <div className="col-12 py-2">
        <div className="skeleton skeleton-label">
          <CustomSkeleton
            count={1}
            height={20}
            width={"10%"}
            customOuterStyle={{ padding: "0" }}
          />
        </div>
        <div className="skeleton skeleton-input">
          <CustomSkeleton
            count={1}
            height={40}
            width={"100%"}
            customOuterStyle={{ padding: "0" }}
          />
        </div>
      </div>
      <div className="col-12 py-2">
        <div className="skeleton skeleton-label">
          <CustomSkeleton
            count={1}
            height={20}
            width={"10%"}
            customOuterStyle={{ padding: "0" }}
          />
        </div>
        <div className="skeleton skeleton-input">
          <CustomSkeleton
            count={1}
            height={40}
            width={"100%"}
            customOuterStyle={{ padding: "0" }}
          />
        </div>
      </div>
      <div className="col-12 py-2">
        <div className="row d-flex justify-content-between">
          <div className="col-2">
            <div className="skeleton skeleton-label">
              <CustomSkeleton
                count={1}
                height={20}
                width={"60%"}
                customOuterStyle={{ padding: "0" }}
              />
            </div>
            <div className="skeleton skeleton-select">
              <CustomSkeleton
                count={1}
                height={30}
                width={"100%"}
                customOuterStyle={{ padding: "0" }}
              />
            </div>
          </div>
          <div className="col-2">
            <div className="skeleton skeleton-label">
              <CustomSkeleton
                count={1}
                height={20}
                width={"60%"}
                customOuterStyle={{ padding: "0" }}
              />
            </div>
            <div className="skeleton skeleton-select">
              <CustomSkeleton
                count={1}
                height={30}
                width={"100%"}
                customOuterStyle={{ padding: "0" }}
              />
            </div>
          </div>
          <div className="col-2">
            <div className="skeleton skeleton-label">
              <CustomSkeleton
                count={1}
                height={20}
                width={"60%"}
                customOuterStyle={{ padding: "0" }}
              />
            </div>
            <div className="skeleton skeleton-select">
              <CustomSkeleton
                count={1}
                height={30}
                width={"100%"}
                customOuterStyle={{ padding: "0" }}
              />
            </div>
          </div>
          <div className="col-2">
            <div className="skeleton skeleton-label">
              <CustomSkeleton
                count={1}
                height={20}
                width={"60%"}
                customOuterStyle={{ padding: "0" }}
              />
            </div>
            <div className="skeleton skeleton-select">
              <CustomSkeleton
                count={1}
                height={30}
                width={"100%"}
                customOuterStyle={{ padding: "0" }}
              />
            </div>
          </div>
          <div className="col-2">
            <div className="skeleton skeleton-label">
              <CustomSkeleton
                count={1}
                height={20}
                width={"60%"}
                customOuterStyle={{ padding: "0" }}
              />
            </div>
            <div className="skeleton skeleton-select">
              <CustomSkeleton
                count={1}
                height={30}
                width={"100%"}
                customOuterStyle={{ padding: "0" }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  const ManufacturerSkeleton = () => (
    <tr>
      <td colSpan={5} className="p-0">
        <CustomSkeleton
          height={50}
          customOuterStyle={{ padding: "0", height: "50px" }}
          containerClassName={"d-grid"}
          customInnerStyle={{ borderRadius: "0" }}
        />
      </td>
    </tr>
  );
  const handleCreateRow = async (mid: any) => {
    try {
      const formdata: any = {
        project_id: id,
        project_manufactures_id: mid,
        status: "draft",
      };

      const response =
        await ProjectManufacturesQuotations.$query().store(formdata);

      if (response) {
        setToast("success", "Quotation Request created successfully");
        setRefreshKey((prev) => prev + 1); //
      } else {
        setToast("error", "Failed to create quotation request");
      }
    } catch (error: any) {
      setToast(
        "error",
        error?.message ||
          "An error occurred while creating the quotation request",
      );
    }
  };

  return (
    <>
      <Breadcrumb>
        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
        <Breadcrumb.Item href="/projects">Projects</Breadcrumb.Item>
        <Breadcrumb.Item active className="fw-bold">
          {!id ? "Add Project" : "Edit Project"}
        </Breadcrumb.Item>
      </Breadcrumb>
      <div className="d-flex justify-content-between">
        <h2> {!id ? "Add Project" : "Edit Project"}</h2>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <CustomButton label={`Back`} variant="secondary" onClick={GoBack} />
        </div>
      </div>
      {id && loading ? (
        <CustomFormSkeleton />
      ) : (
        <div>
          <Form onSubmit={() => {}}>
            <div className="row p-2">
              <div className="col-12 py-2">
                <Form.Label>Title*</Form.Label>
                <Form.Control
                  type="text"
                  className="py-1"
                  onChange={handleInputChange}
                  name={"title"}
                  value={formData.title}
                  required
                  placeholder="Enter Title"
                />
                {formErrors.title && (
                  <p className="text-danger">{formErrors.title}</p>
                )}
              </div>
              <div className="col-12 py-2">
                <Form.Label>Description*</Form.Label>
                <Form.Control
                  type="text"
                  className="py-1"
                  onChange={handleInputChange}
                  name={"description"}
                  value={formData.description}
                  required
                  placeholder="Enter Description"
                />
                {formErrors.description && (
                  <p className="text-danger">{formErrors.description}</p>
                )}
              </div>
              <div className="col-12 py-2">
                <div className="row d-flex justify-content-between">
                  <div className="col-3">
                    <label htmlFor="company_name">Buyer/Supplier</label>
                    <CustomAsyncSelect
                      customTheme={customTheme}
                      model={BuyersAndSuppliers}
                      label="Project Title"
                      inputfield={"company_name"}
                      fieldName={"company_name"}
                      isMultiSelect={false}
                      addNewBtnStatus={false}
                      formData={"company_name"}
                      customValue={id && formData.buyer_id}
                      onChange={(selectedOption: any) => {
                        setFormData({ ...formData, buyer_id: selectedOption });
                      }}
                    />
                  </div>
                  <div className="col-3">
                    <label htmlFor="company_name">Status</label>
                    <CustomAsyncSelect
                      customTheme={customTheme}
                      model={BuyersAndSuppliers}
                      addNewBtnStatus={false}
                      defaultOptions={
                        id
                          ? [
                              { label: "Draft", value: "draft" },
                              {
                                label: "Ready To Send For Estimate",
                                value: "ready_to_send_for_estimate",
                              },
                              { label: "Close ", value: "close" },
                            ]
                          : [{ label: "Draft", value: "draft" }]
                      }
                      label="Project Title"
                      inputfield={"company_name"}
                      fieldName={"company_name"}
                      isMultiSelect={false}
                      formData={"company_name"}
                      customValue={
                        id
                          ? formData.project_status
                          : { label: "Draft", value: "draft" }
                      }
                      // isdisabled={!id && true}
                      onChange={(selectedOption: any) => {
                        setFormData({
                          ...formData,
                          project_status: selectedOption,
                        });
                        setFormErrors({ ...formErrors, project_status: "" });
                      }}
                    />
                    {formErrors.project_status && (
                      <p className="text-danger">{formErrors.project_status}</p>
                    )}
                  </div>
                  <div className="col-3">
                    <label htmlFor="lead_value">Project Value</label>
                    <Form.Control
                      type="text"
                      className="py-1"
                      onChange={handleInputChange}
                      required
                      name={"project_value"}
                      placeholder="Enter Project Value"
                      value={
                        formData?.project_value !== "undefined"
                          ? formData?.project_value
                          : ""
                      }
                    />
                    {/* {formErrors.project_value && (
                    <p className="text-danger">{formErrors.project_value}</p>
                  )} */}
                  </div>
                  <div className="col-3">
                    <label htmlFor="expected_close_date">
                      Expected Close Date
                    </label>
                    <DatePicker
                      wrapperClassName="d-flex"
                      selected={
                        new Date(formData.expected_closed_date) instanceof
                          Date &&
                        !isNaN(
                          new Date(formData.expected_closed_date).getTime(),
                        )
                          ? formData.expected_closed_date
                          : ""
                      }
                      showYearDropdown
                      placeholderText={
                        dateFormat.replace("dd", "DD").split(" ")[0]
                      }
                      onChange={(date) => {
                        setFormData({
                          ...formData,
                          expected_closed_date: date,
                        });
                      }}
                      dateFormat={
                        dateFormat?.replace("YYYY", "yyyy").split(" ")[0]
                      }
                      className="form-control"
                      onBlur={(e: any) => {
                        let enteredDate = e.target.value;
                        const dateFormatWithoutTime = dateFormat
                          .replace("dd", "DD")
                          .split(" ")[0];
                        enteredDate = enteredDate.replace(
                          /\b(\d{1})\b/g,
                          "0$1",
                        );
                        const isValid = moment(
                          enteredDate,
                          dateFormatWithoutTime,
                        ).isValid();
                        if (isValid) {
                          setFormErrors({
                            ...formErrors,
                            expected_closed_date: "",
                          });
                        } else {
                          setFormData({
                            ...formData,
                            expected_closed_date: "",
                          });
                          if (enteredDate.length > 0) {
                            setFormErrors({
                              ...formErrors,
                              expected_closed_date: `Please select a date in the correct format (${
                                dateFormat.replace("dd", "DD").split(" ")[0]
                              }).`,
                            });
                          } else {
                            setFormErrors({
                              ...formErrors,
                              expected_closed_date: "",
                            });
                          }
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 py-2">
                <div className="row d-flex justify-content-between">
                  <div className="col-3">
                    <label htmlFor="lead_value">Dosage Form*</label>
                    <Form.Control
                      type="text"
                      className="py-1"
                      onChange={handleInputChange}
                      required
                      name={"dosage_form"}
                      placeholder="Enter Dosage Form"
                      value={
                        formData?.dosage_form !== "undefined"
                          ? formData?.dosage_form
                          : ""
                      }
                    />
                    {formErrors.dosage_form && (
                      <p className="text-danger">{formErrors.dosage_form}</p>
                    )}
                  </div>
                  <div className="col-3">
                    <label htmlFor="lead_value">Filling*</label>
                    <Form.Control
                      type="text"
                      className="py-1"
                      onChange={handleInputChange}
                      required
                      name={"filling"}
                      placeholder="Enter filling"
                      value={
                        formData?.filling !== "undefined"
                          ? formData?.filling
                          : ""
                      }
                    />
                    {formErrors.filling && (
                      <p className="text-danger">{formErrors.filling}</p>
                    )}
                  </div>
                  <div className="col-3">
                    <label htmlFor="lead_value">Type of Filling*</label>
                    <Form.Control
                      type="text"
                      className="py-1"
                      onChange={handleInputChange}
                      required
                      name={"type_of_filling"}
                      placeholder="Enter type of filling"
                      value={
                        formData?.type_of_filling !== "undefined"
                          ? formData?.type_of_filling
                          : ""
                      }
                    />
                    {formErrors.type_of_filling && (
                      <p className="text-danger">
                        {formErrors.type_of_filling}
                      </p>
                    )}
                  </div>
                  <div className="col-3">
                    <label htmlFor="packaging_material">
                      Packaging material*
                    </label>
                    <div className="input-group align-items-center">
                      <Form.Control
                        type="file"
                        id="packaging_material"
                        name="packaging_material"
                        className="form-control hide-file-text"
                        onChange={handleInputChange}
                      />
                      {fileName && (
                        <>
                          <Form.Control
                            type="text"
                            value={fileName}
                            className="text-truncate bg-white border-start-0"
                            readOnly
                          />
                          {fileUrl && (
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-link"
                              download
                            >
                              <Download />
                            </a>
                          )}
                        </>
                      )}
                    </div>
                    {formErrors.packaging_material && (
                      <p className="text-danger">
                        {formErrors.packaging_material}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </div>
      )}
      <CreateRow
        FormTableFields={productTableFields}
        setCardsData={setProducts}
        cardsData={products}
        initializedProduct={productDetails}
        formErrors={productFormErrors}
        updateStatus={isUpdated}
        cardShowStatus={true}
        cardName="Product Content"
        setFormErrors={setProductFormErrors}
      />
      <div className="row py-4">
        <h2>{id ? "Select Manufacturers" : "Add Manufacturers"}</h2>
        <Card>
          <Card.Body>
            {id && (
              <Table>
                <thead>
                  <tr>
                    <th className="text-center">ID</th>
                    <th className="text-center">Name</th>
                    <th className="text-center">Status</th>
                    <th className="text-center">Quotation Request</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {loadingForSelectedManufacturers ? (
                    <ManufacturerSkeleton />
                  ) : (
                    selectedManufacturers.map(
                      (manufacturer: any, index: number) => (
                        <tr key={index}>
                          <td className="text-center" style={{ width: "10%" }}>
                            {index + 1}
                          </td>
                          <td className="text-center" style={{ width: "20%" }}>
                            {manufacturer.label}
                          </td>
                          <td
                            style={{ width: "35%" }}
                            className="form-control-bottom-border text-center"
                          >
                            <CustomAsyncSelect
                              customTheme={customTheme}
                              model={BuyersAndSuppliers}
                              addNewBtnStatus={false}
                              defaultOptions={[
                                { label: "Draft", value: "draft" },
                                { label: "Approved", value: "approved" },
                                { label: "Rejected ", value: "rejected" },
                                {
                                  label: "Requested For Quotation",
                                  value: "requested_for_quotation",
                                },
                              ]}
                              label="Project Title"
                              inputfield={"company_name"}
                              fieldName={"company_name"}
                              isMultiSelect={false}
                              formData={"company_name"}
                              customValue={
                                id && manufacturer.project_manufactures_status
                              }
                              onChange={(selectedOption: any) => {
                                handleManufacturerChange(
                                  selectedOption,
                                  index,
                                  false,
                                );
                              }}
                              isdisabled={disabledDraftRows[index]}
                            />
                          </td>
                          <td className="text-center" style={{ width: "25%" }}>
                            {!disabledDraftRows[index] && (
                              <CustomButton
                                label={"Create"}
                                variant="success"
                                onClick={() => handleCreateRow(manufacturer.id)}
                              />
                            )}
                          </td>
                          <td style={{ width: "10%" }}>
                            <span
                              onClick={() => removeManufacturer(index)}
                              style={{
                                cursor: "pointer",
                                color: "red",
                                marginRight: "50px",
                              }}
                            >
                              <XCircle />
                            </span>
                          </td>
                        </tr>
                      ),
                    )
                  )}
                </tbody>
              </Table>
            )}
            {id && <h5 className="my-3">Add Manufacturer</h5>}
            <div className="form-control-bottom-border">
              {id && loadingForSelectedManufacturers ? (
                <CustomSkeleton
                  height={40}
                  customOuterStyle={{ padding: "0" }}
                />
              ) : (
                <CustomAsyncSelect
                  customTheme={customTheme}
                  model={BuyersAndSuppliers}
                  addNewBtnStatus={false}
                  label="Project Title"
                  inputfield={"company_name"}
                  fieldName={"company_name"}
                  isMultiSelect={true}
                  formData={"company_name"}
                  customFilter={[
                    {
                      field: "company_type",
                      operator: "in",
                      value: ["supplier", "both"],
                    },
                  ]}
                  onChange={(selectedOption: any) =>
                    handleManufacturerChange(
                      selectedOption,
                      selectedManufacturers.length,
                      true,
                    )
                  }
                  customValue={id && selectedManufacturers}
                  // isClearable={false}
                />
              )}
            </div>
            {id && (
              <div>
                {disabledDraftRows.length !== 0 && (
                  <div className="mb-4 d-flex justify-content-end mt-3">
                    <CustomButton
                      type="submit"
                      label={"Add Manufacturers"}
                      variant="primary"
                      onClick={() => handleSubmit(true)}
                      size="sm"
                      disableStatus={submitting}
                      spinnerStatus={submitting}
                    />
                  </div>
                )}
              </div>
            )}
          </Card.Body>
        </Card>
        {manufacturerError && (
          <span className="text-danger">Manufacturers are required</span>
        )}
      </div>
      <div className="mb-4 d-flex justify-content-end mt-3">
        <CustomButton
          type="submit"
          label={"Submit"}
          variant="primary"
          onClick={() => handleSubmit(false)}
          size="sm"
          disableStatus={submitting}
          spinnerStatus={submitting}
        />
      </div>
      {id && (
        <div className="mt-2">
          <QuotationRequestsCard key={refreshKey} />
        </div>
      )}
    </>
  );
};

export default AddUpdate;
